// Utilisation de la variable d'environnement pour l'URL backend
// Cela permet à chaque environnement (local, preview, production) d'utiliser son propre backend
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

// Log pour vérification
console.log('🔧 Backend URL configuré:', BACKEND_URL);
console.log('🌍 Hostname actuel:', typeof window !== 'undefined' ? window.location.hostname : 'SSR');
console.log('🔒 Protocol:', typeof window !== 'undefined' ? window.location.protocol : 'N/A');

export { BACKEND_URL, API };
